let ua = navigator.userAgent.toLowerCase();

export function isSafari() {
    if (ua.indexOf('safari') != -1) {
        if (ua.indexOf('chrome') > -1) {
            return false
        } else {
            return true;
        }
    }
}